module.exports = __webpack_public_path__ + "img/112.1a4aec8a.png";